var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmarDatoPromotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#88b86e;}.cls-2{fill:#be8244;}.cls-3{fill:#9a632f;}.cls-4{fill:#fff;}.cls-5{fill:#f3d585;}.cls-6{fill:#4d4d4d;}.cls-7{fill:#de9c33;}.cls-8{fill:gray;}.cls-9{fill:#f3f3e5;}.cls-10{fill:#cd686a;}.cls-11{fill:#e8b954;}.cls-12{fill:#ab382d;}.cls-13{fill:#395c82;}.cls-14{fill:#eee375;}.cls-15{fill:#6baec9;}.cls-16{fill:#d2dde6;}.cls-17{fill:#d38aaf;}.cls-18{fill:#c2fb3b;}.cls-19{fill:#9cdd05;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "confirmar_agregar_datos_cliente_promotor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,78.28h81.12V88.42H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.34,88.42H92v23.66H41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.48,64.76H75.14V78.28H51.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.55,41.1H70.07V51.24a6.76,6.76,0,1,1-13.52,0V41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.9,51.24h30.42V71.52H81.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92,88.42H115.7v23.66H92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92,71.52h10.14v6.76H92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87,63.07h3.38v3.38H87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.31,31A10.14,10.14,0,0,1,73.45,41.1H53.17A10.14,10.14,0,0,1,63.31,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.62,49.55H65v3.38H61.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M61.62,64.76H65v8.45H61.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M25.92,90.62h37.2v22A1.37,1.37,0,0,1,61.74,114H27.3a1.37,1.37,0,0,1-1.38-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.12,112H28v-5.51h1.37v4.13h2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.5,110.6h1.38V112H33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M39.7,101V90.62h9.64V101l-2.75-2.07L44.52,101l-2.07-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.72,107.16h9.64v4.13H50.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.1,101l1.37-6.89,6.89,1.38L59,102.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.92,94.76H36.25V103H25.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28,96.82h4.82V98.2H28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28,99.58h2.75V101H28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.12,99.58H33.5V101H32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M37.83,107.36l2.76-2.76,1,1-2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M42,106.67l2.75-2.76,1,1-2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.1,74.09h-22V90.62H59V81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M52.1,74.09V81H59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M32.12,81H39v1.38H32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M32.12,83.74H33.5v1.37H32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M34.88,83.74H39v1.37H34.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M32.12,86.49h8.27v1.38H32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M40.39,81H50v1.38H40.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M40.39,83.74H52.1v1.37H40.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M41.76,86.49h2.76v1.38H41.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M32.12,77.54H45.9v1.37H32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M45.9,86.49H50v1.38H45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.71,44.19l-2.46-2.55a.88.88,0,0,0-1.25,0l-5.81,5.63-3.27,3.17-2.46-2.55a1,1,0,0,0-.62-.27.91.91,0,0,0-.63.25l-2.55,2.47a.88.88,0,0,0,0,1.25l5.55,5.72a.85.85,0,0,0,.62.27.93.93,0,0,0,.63-.25l2.63-2.55,9.62-9.32a.86.86,0,0,0,.27-.62A.83.83,0,0,0,116.71,44.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M103.19,57.29a.85.85,0,0,0,.62.27.93.93,0,0,0,.63-.25l2.63-2.55.12-7.51-3.27,3.17-2.46-2.55a1,1,0,0,0-.62-.27.91.91,0,0,0-.63.25l-2.55,2.47a.88.88,0,0,0,0,1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmarDatoPromotor);
export default __webpack_public_path__ + "static/media/confirmar_dato_promotor.5f9bca317738371da8e97b2fcc427435.svg";
export { ForwardRef as ReactComponent };